<script lang="ts" setup>
const { data: socials } = await useFetch("/api/socials");

const logoUrl = useState<string>("logo-url");
const logoFooterUrl = useState<string>("logo-footer-url");
const aboutMeData = useState<AboutMeData>("about-me-data");
</script>

<template>
  <footer class="footer-style-two">
    <!-- Start footer bottom -->
    <div class="footer-top-2">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <div class="footer-logo-area text-center">
              <h2 class="logo">
                <a href="#"><img height="150" :src="logoFooterUrl" alt="Met Devoti logo" /></a>
                <img height="50" :src="logoUrl" alt="Met Devoti Logo" />
              </h2>
              <p style="color: var(--paragraph-color)">
                {{ aboutMeData.footerText }}
              </p>
              <NuxtLink to="/contact" class="button-boxed" style="margin-top: 1.5rem">Contact Me <i class="ti-arrow-right"></i></NuxtLink>
            </div>
            <div class="social-bookmark-area">
              <ul class="social-bookmark list-inline">
                <li v-if="socials?.facebook">
                  <a :href="socials.facebook"><i class="fa fa-facebook"></i></a>
                </li>
                <li v-if="socials?.x">
                  <a :href="socials.x"><i class="fa fa-twitter"></i></a>
                </li>
                <li v-if="socials?.google">
                  <a :href="socials.google"><i class="fa fa-google-plus"></i></a>
                </li>
                <li v-if="socials?.instagram">
                  <a :href="socials.instagram"><i class="fa fa-instagram"></i></a>
                </li>
                <li v-if="socials?.soundcloud">
                  <a :href="socials.soundcloud"><i class="fa fa-soundcloud"></i></a>
                </li>
                <li v-if="socials?.linkedin">
                  <a :href="socials.linkedin"><i class="fa fa-linkedin"></i></a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- End footer bottom -->
    <!-- Start footer bottom -->
    <div class="footer-bottom">
      <div class="container">
        <div class="row">
          <div class="col-md-12 col-sm-12">
            <div class="copy-right">
              <p>
                All &copy; reserved by
                <NuxtLink to="/about-me">Met Devoti</NuxtLink>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- End footer bottom -->
  </footer>
</template>
<style scoped>
.social-bookmark li {
  border-left-color: var(--subtitle-color) !important;
}
.footer-bottom {
  border-top-color: var(--subtitle-color);
  background-color: var(--background-color);
  color: var(--paragraph-color);
}
.copy-right p {
  color: var(--paragraph-color);
}
.copy-right p a {
  color: var(--primary-color);
}
</style>
